import { PAGES } from "@dune/types";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
	useGetSyndicProjects,
	useGetSyndicTasks,
} from "../../api/queries/dashboard.queries";
import { useMe } from "../../api/queries/users.queries";
import ErrorBoundary from "../../component/common/ErrorBoundary";
import { DashboardHeader } from "./components/DashboardHeader";
import { ProjectsSection } from "./components/ProjectsSection";
import { TasksSection } from "./components/TasksSection";

const SyndicDashboard: React.FC = () => {
	const navigate = useNavigate();
	const { me } = useMe();

	const syndicTasksQuery = useGetSyndicTasks();
	const syndicProjectsQuery = useGetSyndicProjects();

	const handleNewProject = () => {
		navigate(PAGES.PROJECTS.create);
	};

	return (
		<div className="h-screen overflow-hidden flex flex-col bg-white rounded-lg border">
			<ErrorBoundary fallbackMessage="Erreur lors du chargement du tableau de bord">
				<div className="flex-shrink-0 p-6 pb-4">
					<DashboardHeader
						firstName={me?.firstname || ""}
						onNewProject={handleNewProject}
					/>
				</div>
				<div className="flex-1 px-6 pb-6 overflow-hidden">
					<div className="h-full grid grid-cols-4 gap-6">
						<div className="col-span-1 flex flex-col gap-4 overflow-hidden">
							<div className="flex-1 min-h-0">
								<TasksSection
									tasksData={syndicTasksQuery.data}
									isLoading={syndicTasksQuery.isLoading}
									error={syndicTasksQuery.error}
								/>
							</div>
						</div>
						<div className="col-span-3 min-h-0">
							<ProjectsSection
								projectsData={syndicProjectsQuery.data}
								isLoading={syndicProjectsQuery.isLoading}
								error={syndicProjectsQuery.error}
							/>
						</div>
					</div>
				</div>
			</ErrorBoundary>
		</div>
	);
};

export default SyndicDashboard;
